module.exports = __webpack_public_path__ + "img/new_index_industry_icon4.50108209.png";